import React from 'react'

import MenuSection from '../MenuSection'
import DateMenuSection from '../DateMenuSection'

import { DUE_OPTIONS, DUE_RANGE } from '../../helpers/parse'
import { useTaskFilters } from '@SonarCX/providers/TaskFiltersProvider'

type DueDateFilterProps = {
  checkFilters?: boolean
  menuMode?: boolean
  closeModal?: () => void
}

const DueDateFilter: React.FC<DueDateFilterProps> = props => {
  const { state, handleChange } = useTaskFilters()

  return (
    <MenuSection
      title='Due Dates'
      options={DUE_OPTIONS}
      value={state.dueValue}
      setValue={handleChange('dueValue')}
      unassignedOpt='All Due Dates'
      {...props}
    >
      {state.dueValue === DUE_RANGE && (
        <DateMenuSection
          startValue={state.dueStartValue}
          endValue={state.dueEndValue}
          setValue={handleChange}
        />
      )}
    </MenuSection>
  )
}

export default DueDateFilter
